import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import { Button } from 'components/Forms'
import { openModal } from 'store/actions/modals'

const DeleteButton = ({ buttonClass, buttonText, children, onClick, requireConfirmation, title, row, archive, disabled, disableClose }) => {
  const dispatch = useDispatch()

  return (
    <Button
      onClick={() => dispatch(openModal('DeleteButtonModal', { children, onClick, requireConfirmation, title, row, archive, disableClose }))}
      text={buttonText}
      className={buttonClass}
      disabled={disabled}
    />
  )
}

export default DeleteButton

DeleteButton.propTypes = {
  buttonClass: PropTypes.string,
  buttonText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  onClick: PropTypes.func.isRequired,
  requireUsername: PropTypes.bool,
  title: PropTypes.string.isRequired,
  disableClose: PropTypes.bool
}

DeleteButton.defaultProps = {
  buttonClass: `btn btn-danger btn-sm`,
  buttonText: `DELETE`
}
